module.exports = __webpack_public_path__ + "img/dummy7.27aa56f.jpg";